import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'account-reward-card',
    templateUrl: './reward-card.component.html',
    styleUrls: ['./reward-card.component.scss'],
    standalone: false
})
export class RewardCardComponent implements OnInit {
  @Input() cardNumber: string;
  @Input() showQr: boolean = false;
  @Output() showQrChange = new EventEmitter<boolean>();

  cardImage: string = 'assets/imgs/account/card.png';


  constructor() { }

  ngOnInit() { }

  public onCardClicked() {
    this.showQr = !this.showQr;
    this.showQrChange.emit(this.showQr);
  }
}